export default {
  meta: {
    'key-content': '免费语音通话, 安全通信, 即时通信, 阅后即焚, 安全聊天, 加密聊天, Telegram, Sugram, Whatsapp',
    'description-content': 'Crait是一款安全通信和协作工具，旨在提升个人和组织的沟通效率的同时保护数据和信息安全。通过企业级的数据加密，用户的隐私将会得到有效保护。',
    'h-m-title': 'Crait | 聊任何你想聊的'
  },
  head: {
    'home': '首页',
    'features': '产品',
    'pricing': '定价',
    'resources': '资源',
    'openapi': '开放平台',
    'contact': '联系我们',
    'download': '下载',
    'login': '登录',
    'console': '管理中台',
    'CraitForWeb': 'Crait web版'
  },
  home: {
    'title1': '聊任何你想聊的',
    'title2': '安全即时通信',
    'subtitle': '端到端加密.阅后即焚.免费音视频电话',
    'placeholder': '您的邮箱，电话或用户名',
    'getstart': '即刻试用',
    'contitle': 'Crait的优势',
    'intro1-title': '为多人沟通设计',
    'intro1-detail': '支持创建1000人群组和多人电话会议，所有消息、图片、视频均受到端到端加密保护',
    'intro2-title': '为安全通讯设计',
    'intro2-detail': '行业标准的256位AES端到端加密技术，所有通讯均有传输层保护（TLS），有效防止中间人攻击',
    'intro3-title': '为高度可定制化设计',
    'intro3-detail': '组织管理者可以在Crait中创建组织架构，同时通过权限控制，来自定义组织中的数据访问权限',
    'intro4-title': '為安全通訊設計',
    'intro4-detail': '行業標準的256位AES端到端加密技術，所有通訊均有傳輸層保護（TLS），有效防止中間人攻擊',
    'keyfeature-title': '核心功能',
    'keyfeature-list1': '安全聊天',
    'keyfeature-list2': '安全语音',
    'keyfeature-list3': '安全文件传输',
    'keyfeature-list4': '支持多平台',
    'keyfeature-list5': '语音消息',
    'keyfeature-list6': '安全云盘',
    'learnmore': '了解更多',
    'download-title': '支持各大平台',
    'download-detail': 'Crait是一款为安全团队沟通和协作而设计的加密通信软件，支持跨平台间同步用户数据，旨在提升工作效率和安全性',
    'err-tip-email': '抱歉，邮箱不正确',
    'err-tip-phone': '抱歉，手机号码不正确',
    'click': '点击',
    'wx-tip1': '右上角的按钮',
    'select': '选择',
    'wx-tip2': '在浏览器打开'
  },
  features: {
    'f-title': '安全的加密通讯，没有人知道你和你朋友的聊天内容',
    'feature-title': '安全即时通信',
    'feature-list1-title': '安全聊天',
    'feature-list1-detail': '支持点对点聊天和最大1000人的群聊',
    'feature-list2-title': '安全语音',
    'feature-list2-detail': '支持点对点语音呼叫和最多20人的电话会议',
    'feature-list3-title': '电话会议',
    'feature-list3-detail': '支持端到端加密的电话会议，自带“语音聚焦”功能，自动增加发言人音量的同时过滤环境噪音',
    'feature-list4-title': '跨平台同步',
    'feature-list4-detail': '支持各大主流平台',
    'feature-list5-title': '语音消息',
    'feature-list5-detail': '支持发送语音消息',
    'feature-list6-title': '安全文件分享',
    'feature-list6-detail': '支持在群组中安全分享最大100MB的文件',
    'feature-list7-title': '安全云盘',
    'feature-list7-detail': '支持最大1GB的加密个人云盘',
    'feature-list8-title': '群发消息',
    'feature-list8-detail': '支持向个人好友或组织成员群发消息',
    'feature-list9-title': '安全性',
    'feature-list9-detail': '集成阅后即焚、消息防截屏、消息阅读回执功能',
    'other-feature': '其他功能',
    'other-list1-title': '可定制插件',
    'other-list1-detail': '客户可根据行业或组织的特定需求定制插件，例如日历分享、会议室预定、办公室物资管理等',
    'other-list2-title': '搜索',
    'other-list2-detail': '支持跨聊天搜索历史消息、组织内跨部门搜索成员'
  },
  pricing: {
    'p-title1': '功能',
    'p-title2': 'Crait',
    'p-title3': 'Crait Pro',
    'unlimited': '无限',
    'tr1-td1': '群组数量限制',
    'tr2-td1': '群成员人数限制',
    'tr3-td1': '广播消息人数限制',
    'tr4-td1': '电话会议人数限制',
    'tr5-td1': '群空间容量',
    'tr6-td1': '个人云盘容量',
    'tr7-td1': '视频电话',
    'tr8-td1': '定制插件',
    'tr8-td2': '不支持',
    'tr8-td3': '按单个插件计费',
    'tr9-td1': '客户服务和技术支持',
    'tr9-td2': 'APP内技术支持',
    'tr9-td3': '7x24小时 (邮件或电话)',
    'tr10-td1': '提供团队管理平台',
    'tr11-td1': '全平台支持',
    'tr12-td1': '价格',
    'tr12-td2': '免费',
    'tr12-td3': '2.99美元每月',
    'btn1': '即刻试用',
    'btn2': '现在升级'
  },
  resources: {
    'readmore1': '阅读更多 ->',
    'readmore2': '阅读更多',
    'r-title1': '白皮书',
    'r-title2': '博客',
    'subtitle1': 'WHAT IS CRAIT?',
    'detail1': 'Crait is where secure communication and collaboration happens. It is a secure messaging tool designed to make working life easier and more productive for work-groups...',
    'subtitle2': 'Data Breach Trends',
    'detail2': 'Data breaches are no good. It will serve companies well to reexamine their basic security hygiene with a deliberate view of strengthening their respective security postures...',
    'subtitle3': 'Small Enterprises Are Easy Targets',
    'detail3': 'Not all commonsensical ideas hold water. One example of a commonplace idea that does not match reality is the notion that hackers only target big businesses. The rising number of cyber attacks on small businesses strongly contradicts this seemingly prevalent sentiment that small businesses aren’t the target of hacks. Let’s examine the facts...'
  },
  contact: {
    'c-title1': '欢迎您与我们进一步沟通了解更多关于Crait的信息',
    'c-title2': '请提供更多关于您组织的信息，我们的销售人员会很快与您取得联系',
    'firstname': '姓氏 *',
    'lastname': '名字 *',
    'workemail': '工作邮箱 *',
    'phone': '电话号码 *',
    'company': '组织名称 *',
    'size': '组织规模 *',
    'location': '地点',
    'industry': '行业',
    'send': '发送',
    'emaillabel': '邮箱: ',
    'email': 'info@craitapp.com'
  },
  download: {
    'intro': 'Crait是一款为安全团队沟通和协作而设计的加密通信软件，支持跨平台间同步用户数据，旨在提升工作效率和安全性',
    'd-title': '应用支持各大平台',
    'sub-intro1': '您可以扫码或者点击下方按钮下载Crait.',
    'sub-intro2': '或者即刻开始使用Crait Web版',
    'home-download-title1': '协作新方式',
    'home-download-title2': '免费IM',
    'home-download-title3': '邮件',
    'home-download-title4': '电话会议',
    'home-download-title5': '前往Crait Web版',
    'home-download-title6': '下载Crait PC版',
    'home-download-title7': '即刻试用',
    'home-download-title8': '云盘',
    'download-getApp': '获取应用程序 ',
    'download-iphone': 'iPhone',
    'download-scanCode': '扫码',
    'download-dlApp': '下载App',
    'download-gphone': 'Android',
    'download-pc': 'PC',
    'download-chrome': 'Chrome',
    'download-title-m': '协作新方式',
    'download-dl-btn': '即刻试用'
  },
  payment: {
    'prices-payment-title1': '购买账号',
    'prices-payment-title2': '请输入需要购买Crait Pro的账号',
    'prices-payment-title3': '请选择您希望购买的方案',
    'prices-payment-title4': '请选择',
    'prices-payment-title5': '合计',
    'prices-payment-title6': '支付方式',
    'prices-payment-title7': 'PayPal',
    'prices-payment-title8': '立即支付',
    'prices-payment-title9': '开通Crait Pro即表示您同意以下协议',
    'prices-payment-title10': 'Crait付费会员协议',
    'prices-payment-title11': '隐私政策',
    'prices-payment-title12': '网络错误!',
    'prices-payment-title13': '请输入已注册的Crait账号'
  },
  confirm: {
    'prices-confirm-title1': '购买账号',
    'prices-confirm-title2': '已选择的方案',
    'prices-confirm-title3': '合计',
    'prices-confirm-title4': '支付方式',
    'prices-confirm-title5': '前往支付',
    'prices-confirm-title6': '正在前往第三方支付页面...',
    'prices-confirm-title7': '请在打开的第三方支付页面中完成支付',
    'prices-confirm-title8': '未完成支付',
    'prices-confirm-title9': '已完成支付',
    'prices-confirm-title10': '网络错误!'
  },
  success: {
    'prices-success-title1': '您的Crait Pro权限已购买完成',
    'prices-success-title2': '待支付信息确认后，重新登录账号后即可享有Crait Pro权益',
    'prices-success-title3': '购买账号',
    'prices-success-title4': '已购买的方案'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/cn.js